import { UpdatableModel } from 'projects/common/src/lib/models/updatable-model';
import { WizardStepComponent } from './wizard-step.component';

export class WizardStepVisibilityEvent extends UpdatableModel<WizardStepVisibilityEvent> {
  step: WizardStepComponent;
  visible: boolean;
}
